import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login/6.png'
import _imports_1 from '@/assets/img/login/1.png'
import _imports_2 from '@/assets/img/login/5.png'
import _imports_3 from '@/assets/img/login-person.png'
import _imports_4 from '@/assets/img/login/login-left2.jpg'
import _imports_5 from '@/assets/img/phone.png'
import _imports_6 from '@/assets/img/password.png'
import _imports_7 from '@/assets/img/username.png'


const _withScopeId = n => (_pushScopeId("data-v-0078561f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "png png1",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "png png2",
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "png png3",
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "login-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "png png4",
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "login-left" }
const _hoisted_8 = { class: "login-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("智能雇主系统")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-whiteRow" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-words" }, [
  /*#__PURE__*/_createTextVNode(" Welcome to use"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Intelligent insurance system ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "login-photo",
  alt: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "login-photo-orange",
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "login-form" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "welcome"
}
const _hoisted_18 = { class: "form" }
const _hoisted_19 = { class: "form-title" }
const _hoisted_20 = {
  key: 0,
  class: "tab-container"
}
const _hoisted_21 = {
  key: 1,
  class: "title"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "input-block" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-icon-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "input-icon",
    src: _imports_5,
    alt: ""
  })
], -1))
const _hoisted_25 = { class: "input-block mt-20" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-icon-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "input-icon",
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_27 = { class: "input-opt-block" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "input-block" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-icon-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "input-icon",
    src: _imports_7,
    alt: ""
  })
], -1))
const _hoisted_32 = { class: "input-block mt-20" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-icon-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "input-icon",
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("登录 ")
const _hoisted_35 = { class: "foot" }
const _hoisted_36 = {
  style: {"color":"#8691a3"},
  target: "_blank",
  href: "https://beian.miit.gov.cn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.projectName), 1),
            _hoisted_9,
            _hoisted_10
          ]),
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("img", {
            class: "login-logo",
            src: _ctx.loginLogo,
            alt: ""
          }, null, 8, _hoisted_16),
          (_ctx.loginLogo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, "欢迎登录雇主投保系统"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_ctx.loginMode === 'both')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["tab-item", { active: _ctx.currentMode === 'mobile' }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentMode = 'mobile'))
                    }, " 快捷登录 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["tab-item", { active: _ctx.currentMode === 'account' }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentMode = 'account'))
                    }, " 密码登录 ", 2)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.loginMode === "sms" ? "快捷登录" : "密码登录"), 1))
            ]),
            (_ctx.currentMode=='mobile')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.phone,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                      placeholder: "请输入手机号"
                    }, null, 8, ["modelValue"]),
                    _hoisted_24
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.code,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.code) = $event)),
                      onKeyup: _withKeys(_ctx.submit, ["enter"]),
                      placeholder: "请输入验证码"
                    }, null, 8, ["modelValue", "onKeyup"]),
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      (_ctx.time)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.time) + "s", 1))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "link",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getSms && _ctx.getSms(...args)))
                          }, "获取验证码"))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.username,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.username) = $event)),
                      placeholder: "请输入用户名"
                    }, null, 8, ["modelValue"]),
                    _hoisted_31
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_el_input, {
                      type: "password",
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.password) = $event)),
                      onKeyup: _withKeys(_ctx.submit, ["enter"]),
                      placeholder: "请输入密码"
                    }, null, 8, ["modelValue", "onKeyup"]),
                    _hoisted_33
                  ])
                ])),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "btn",
              disabled: !((_ctx.phone && _ctx.code) || (_ctx.username && _ctx.password)),
              round: "",
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("a", _hoisted_36, _toDisplayString(_ctx.recordNumber), 1)
    ])
  ], 64))
}